/**
 * @ngdoc service
 * @name flowModelOwnerDialogService
 * @module flowingly.runner.services
 *
 * @description A service responsible solely for flow model owner dialog
 */

import { SharedAngular } from '@Client/@types/sharedAngular';
import ISaveFlowModelOwnerModel from '@Shared.Angular/@types/core/api/models/saveFlowModelOwnerModel';
import ISaveReportOwnerModel from '@Shared.Angular/@types/core/api/models/saveReportOwnerModel';
import { PublicType } from '@Shared.Angular/@types/core/contracts/constants/publicType';
import IFlowinglySearchResult from '@Shared.Angular/@types/core/contracts/queryModel/search/flowinglySearchResult';
import { Guid } from '@Shared.Angular/@types/guid';
import angular, { IHttpService } from 'angular';

export default class FlowModelOwnerDialogService {
  public static $inject = ['$http', 'APP_CONFIG'];

  private readonly API_BASE_URL: string;

  constructor(
    private $http: IHttpService,
    private APP_CONFIG: SharedAngular.APP_CONFIG
  ) {
    this.API_BASE_URL = APP_CONFIG.apiBaseUrl;
  }

  public saveFlowModelOwners(model: ISaveFlowModelOwnerModel) {
    return this.$http.post<void>(
      this.API_BASE_URL + `flowmodels/${model.flowModelId}/flowModelOwners`,
      model
    );
  }

  public saveReportOwners(model: ISaveReportOwnerModel) {
    return this.$http.post<void>(
      this.API_BASE_URL + `flowmodels/${model.flowModelId}/reportOwners`,
      model
    );
  }

  public getExistingFlowModelOwners(flowModelId: Guid) {
    return this.$http.get<IFlowinglySearchResult[]>(
      this.API_BASE_URL + `flowmodels/${flowModelId}/flowModelOwners`
    );
  }

  public getExistingReportOwners(flowModelId: Guid) {
    return this.$http.get<IFlowinglySearchResult[]>(
      this.API_BASE_URL + `flowmodels/${flowModelId}/reportOwners`
    );
  }

  public modifyPublicMapSharing(
    flowModelId: Guid,
    isMapPubliclyShareable: boolean,
    publicType: PublicType
  ) {
    return this.$http.put<IResponseData>(
      this.API_BASE_URL +
        'flowmodels/' +
        flowModelId +
        '/modifyPublicMapSharing',
      {
        isPublic: isMapPubliclyShareable,
        publicType: publicType
      }
    );
  }
}

angular
  .module('flowingly.runner.library')
  .service('flowModelOwnerDialogService', FlowModelOwnerDialogService);

export type FlowModelOwnerDialogServiceType = InstanceType<
  typeof FlowModelOwnerDialogService
>;
